// WaiverOverview.jsx
import { useOutletContext } from "react-router-dom";
import { formatWaiverStatus, formatWaiverType } from "./components/helper_fns"

const WaiverOverview = () => {

    const { waiver } = useOutletContext();


  return (
    <div className="p-8">

      <h2 className="text-2xl font-semibold mb-6">
        Waiver Details
      </h2>

      <div className="border rounded-xl overflow-hidden mb-8">

        <div className="grid grid-cols-4 bg-gray-50 px-5 py-4 font-medium">
          <div>Waiver Type</div>
          <div>Status</div>
          <div>Published</div>
          <div>Archived</div>
        </div>

        <div className="grid grid-cols-4 px-5 py-5 border-t">
          <div>{formatWaiverType(waiver.waiverType)}</div>

          <div>
            <span className="px-3 py-1 rounded-full bg-green-100 text-green-800 text-sm">
              {formatWaiverStatus(waiver.waiverStatus)}
            </span>
          </div>

          <div>
            {waiver.publishedAt
              ? new Date(waiver.publishedAt).toLocaleDateString()
              : "—"}
          </div>

          <div>
            {waiver.archivedAt
              ? new Date(waiver.archivedAt).toLocaleString()
              : "—"}
          </div>
        </div>

        <div className="border-t px-5 py-4 bg-gray-50 font-medium">
          Locations
        </div>

        {/*<div className="px-5 py-5">
          {waiver.locations?.map(loc => loc.name).join(", ")}
        </div>*/}
        <div className="px-5 py-5">
        {waiver.locations?.map(
          loc => `${loc.name} (${loc.city}, ${loc.state})`
        ).join(", ")}
        </div>

      </div>

      

    </div>
  );
};

export default WaiverOverview;